import { style } from '@vanilla-extract/css';
import { themeVars } from '../themeVars.css';
import { nToPx } from '../00-functions';
import { defaultTransitionClass, disabledClass } from './utilities.css';

// DEPRECATED -> use FormContainer instead
export const formContainerClass = style({
  width: '80%',
});

// DEPRECATED -> use FormSection instead
export const formGridBaseClass = style({
  display: 'grid',
  gap: themeVars.space.x4,
  margin: nToPx(themeVars.space.x4, 0, themeVars.space.x6, 0),
  alignItems: 'baseline',
});

// DEPRECATED -> use FormSection instead
export const twoColumnGridClass = style([
  formGridBaseClass,
  {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
]);

export const authFormWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x4,
});

export const optionClass = style([
  defaultTransitionClass,
  {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: themeVars.radius.md,
    padding: nToPx(themeVars.space.x2, themeVars.space.x3),
    gap: themeVars.space.x3,

    selectors: {
      [`&:hover:not(${disabledClass})`]: {
        backgroundColor: themeVars.colors.neutrals.grey30,
      },
    },
  },
]);
